<script lang="ts">
	import { frequentlyAskedQuestionsPathMap } from "../../../../core/schema/paths/frequentlyAskedQuestionsPathMap.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import Link from "../Link.svelte";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import Tooltip from "../Tooltip.svelte";

	export let name: string;
	export let image: string;
	export let price: number | undefined;
	export let minimalPrice: number | undefined;
	export let minimalPriceIsFinal = false;

	const { TENANT_LOCALE } = getGlobalSettings();
</script>

<div class="mb-7 mt-10 flex items-center gap-2">
	<StaticPicture {image} alt={name} width={32} height={32} class="aspect-square w-8"></StaticPicture>
	<Tooltip class="relative pr-4 leading-[1.2] sm:text-base">
		<span class="text-md font-semibold">{name}</span>
		<span
			class="bg-grey-200 absolute right-0 top-0 ml-0.5 grid aspect-square h-3 place-items-center rounded-full text-[9px] font-bold"
		>
			?
		</span>

		<div slot="tooltip" class="flex max-w-64 flex-col gap-[.875rem] !font-normal">
			<slot />
			<p>
				Více informací v sekci
				<Link href={frequentlyAskedQuestionsPathMap[TENANT_LOCALE]}>časté dotazy</Link>.
			</p>
		</div>
	</Tooltip>
	<span class="flex flex-1 justify-end text-xs font-semibold transition-all duration-200 sm:text-base">
		{#if price === 0 && minimalPrice === 0 && minimalPriceIsFinal}
			zdarma
		{:else if minimalPrice !== undefined && price === 0 && !minimalPriceIsFinal}
			od&nbsp;{nbspify(formatPrice(minimalPrice, TENANT_LOCALE, false))}
		{:else if minimalPriceIsFinal && minimalPrice !== undefined && price === 0}
			+&nbsp;{nbspify(formatPrice(minimalPrice, TENANT_LOCALE, false))}
		{:else if price !== undefined}
			+&nbsp;{nbspify(formatPrice(price, TENANT_LOCALE, false))}
		{/if}
	</span>
</div>
